import React from 'react';
import { Button } from './ui/button';

const Hero = () => {
  return (
    <section className="relative h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=1920&q=80"
          alt="Jewelry Collection"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
      </div>
      <div className="relative h-full flex items-center justify-center text-center">
        <div className="max-w-3xl px-4 text-white">
          <h1 className="text-6xl font-light tracking-widest mb-4 animate-fade-in">
            TRIO REWARDS
          </h1>
          <div className="w-32 h-px bg-white mx-auto mb-6"></div>
          <p className="text-2xl font-light mb-2 tracking-wide">
            BUY ANY 3 JEWELRY PIECES
          </p>
          <p className="text-5xl font-light tracking-wider">
            GET 15% OFF
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;